/**
 * Pure helpers for rendering account-limit values that come from the
 * server's `getAccountEntitlements`. Extracted from `accounts-counter.tsx`
 * so consumers (e.g. the connect-account modal) can import without
 * pulling in the dashboard counter's React + entity dependency chain
 * (which breaks Jest module resolution for tests that don't mock the
 * full ui-kit). No React, no Redux, no styled-components imports.
 *
 * Server convention (SKE-3484 follow-up): `getAccountEntitlements` returns
 * `Number.MAX_SAFE_INTEGER` when the Chargebee entitlement value is the
 * string "Unlimited", and also when the trial-floor "Unlimited" sentinel
 * kicks in. Half of MAX_SAFE_INTEGER is well above any plausible real
 * cap, so it's a safe sentinel detector.
 */

export const UNLIMITED_LIMIT_THRESHOLD = Number.MAX_SAFE_INTEGER / 2;

export function formatAccountsLimit(
  rawLimit: number | undefined | null
): number | "Unlimited" {
  // null = Custom-tier unlimited sentinel (api/accounts.ts); peer consumers honour this.
  if (rawLimit === null) return "Unlimited";
  // SKE-3543: ?? 0 lets NaN through; Number.isFinite covers null/undefined/NaN/±Infinity.
  const value =
    typeof rawLimit === "number" && Number.isFinite(rawLimit) ? rawLimit : 0;
  return value >= UNLIMITED_LIMIT_THRESHOLD ? "Unlimited" : value;
}
